module.exports = __webpack_public_path__ + "static/img/Logo_Kemko.60acc75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/support/Logo_Kemko.png
// module id = sc6k
// module chunks = 36